import type { AuthAdapter, User } from '@cv-builder/core'

/**
 * Mock auth adapter for demo/development
 * Always returns a demo user without real authentication
 */
export function createMockAuthAdapter(): AuthAdapter {
  const demoUser: User = {
    id: 'demo-user',
    email: 'demo@example.com',
    name: 'Demo User',
  }

  let currentUser: User | null = demoUser
  const listeners: Set<(user: User | null) => void> = new Set()

  const notifyListeners = () => {
    for (const listener of listeners) {
      listener(currentUser)
    }
  }

  return {
    isAuthenticated(): boolean {
      return currentUser !== null
    },

    getUser(): User | null {
      return currentUser
    },

    async getAccessToken(): Promise<string | null> {
      // Demo mode doesn't need real tokens
      return currentUser ? 'demo-token' : null
    },

    async login(): Promise<void> {
      currentUser = demoUser
      notifyListeners()
    },

    async logout(): Promise<void> {
      currentUser = null
      notifyListeners()
    },

    onAuthStateChange(callback: (user: User | null) => void): () => void {
      listeners.add(callback)
      // Immediately call with current state
      callback(currentUser)
      return () => {
        listeners.delete(callback)
      }
    },
  }
}
